import { Link } from "react-router-dom"
import banner1 from "../../../assets/img/BANNER.jpg"
import banner2 from "../../../assets/img/BANNER2.jpg"
import banner3 from "../../../assets/img/BANNER3.jpg"
import BarrasNivelDeServicio from "./NivelDeServicioBarras"
import SLABarras from "./SLABarras"

const IndicadoresContent = () =>{
 return(
    <>
        <div id="content" className="main-content">
        <div className="layout-px-spacing">
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                <ol className="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active m"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img className="d-block w-100" src={banner1} alt="First slide"/>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100" src={banner2} alt="Second slide"/>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100" src={banner3} alt="Third slide"/>
                    </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Anterior</span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Siguiente</span>
                </a>
            </div>
            

            <div className="row layout-top-spacing">
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                   
                    
                    <div className="widget widget-chart-three">
                        <div className="widget-heading">
                            <div className="text-center mt-4">
                                <h5 className="">Nivel de Servicios</h5>
                            </div>
                            {/* <div className="dropdown ">
                                <Link className="dropdown-toggle" to="#" role="button" id="uniqueVisitors" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                                </Link>

                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="uniqueVisitors">
                                    <Link className="dropdown-item" to="#">View</Link>
                                    <Link className="dropdown-item" to="#">Update</Link>
                                    <Link className="dropdown-item" to="#">Download</Link>
                                </div>
                            </div> */}

                        </div>
                        <div className="d-flex justify-content-center mb-2">
                            <BarrasNivelDeServicio/>
                        </div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div className="widget widget-chart-three">
                        <div className="widget-heading">
                            <div className="text-center mt-4">
                                <h5 >SLA</h5>
                            </div>

                            {/* <div className="dropdown ">
                                <a className="dropdown-toggle" href="#" role="button" id="uniqueVisitors" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                                </a>

                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="uniqueVisitors">
                                    <Link className="dropdown-item" to="#">View</Link>
                                    <Link className="dropdown-item" to="#">Update</Link>
                                    <Link className="dropdown-item" to="#">Download</Link>
                                </div>
                            </div> */}
                        </div>
                        <div className="d-flex justify-content-center mb-2">
                            <SLABarras/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
 )

}


export default IndicadoresContent